const buildUrlMapper = ({ eventId, leadId, miniSessionId, appointmentId }) => {
  function fetchAutomationsUrl() {
    if(eventId) {
      return `/api/v1/events/${eventId}/automated_events`
    }
    else if(leadId) {
      return `/api/v1/leads/${leadId}/automated_events`
    }
    else if(miniSessionId) {
      return `/api/v1/mini_sessions/${miniSessionId}/automated_events`
    }
    else if(appointmentId) {
      return `/api/v1/appointments/${appointmentId}/automated_events`
    }
    else {
      return null
    }
  }

  function fetchInvitationsUrl() {
    if(eventId) {
      return `/api/v1/events/${eventId}/automated_events/invitation_templates`
    }
    else {
      return null
    }
  }

  function resendInvitationUrl(userId) {
    if(!eventId) return null

    return `/events/${eventId}/resend_invitation_to_user?user_id=${userId}`
  }

  function sendNowUrl(templateId) {
    if(eventId) {
      return `/automated_events/${templateId}/perform_event_send?event_id=${eventId}`
    }
    else if(leadId) {
      return `/automated_events/${templateId}/perform_lead_send?lead_id=${leadId}`
    }
    else if(miniSessionId) {
      return `/automated_events/${templateId}/perform_mini_session_send?mini_session_id=${miniSessionId}`
    }
    else if(appointmentId) {
      return `/automated_events/${templateId}/perform_appointment_send?appointment_id=${appointmentId}`
    }
  }

  function addToReviewListUrl(templateId) {
    if(eventId) {
      return `/automated_events/${templateId}/perform_event_add_to_review_queue?event_id=${eventId}`
    }
    else if(leadId) {
      return `/automated_events/${templateId}/perform_lead_add_to_review_queue?lead_id=${leadId}`
    }
    else if(miniSessionId) {
      return `/automated_events/${templateId}/perform_mini_session_add_to_review_queue?mini_session_id=${miniSessionId}`
    }
    else if(appointmentId) {
      return `/automated_events/${templateId}/perform_appointment_add_to_review_queue?appointment_id=${appointmentId}`
    }
  }

  function showTemplateUrl(templateId) {
    return `/admin/custom_templates/${templateId}`
  }

  function showAutomatedEventUrl(templateId) {
    return `/admin/automated_events/${templateId}`
  }

  function personalizeEmailUrl(templateId) {
    if(eventId) {
      return `/events/${eventId}/messages/new?automated_event_id=${templateId}`
    }
    else if(leadId) {
      return `/admin/leads/${leadId}/messages/new?automated_event_id=${templateId}`
    }
    else if(miniSessionId) {
      return `/mini_sessions/${miniSessionId}/messages/new?automated_event_id=${templateId}`
    }
    else if(appointmentId) {
      return `/appointments/${appointmentId}/messages/new?automated_event_id=${templateId}`
    }
  }

  function personalizeSmsUrl(templateId) {
    if(eventId) {
      return `/events/${eventId}/messages/new?automated_event_id=${templateId}`
    }
    else if(leadId) {
      return `/admin/leads/${leadId}/messages/new?automated_event_id=${templateId}`
    }
    else if(miniSessionId) {
      return `/mini_sessions/${miniSessionId}/messages/new?automated_event_id=${templateId}`
    }
    else if(appointmentId) {
      return `/appointments/${appointmentId}/messages/new?automated_event_id=${templateId}`
    }
  }


  return {
    addToReviewListUrl,
    fetchAutomationsUrl,
    fetchInvitationsUrl,
    personalizeEmailUrl,
    personalizeSmsUrl,
    resendInvitationUrl,
    sendNowUrl,
    showAutomatedEventUrl,
    showTemplateUrl,
  }
}

export default buildUrlMapper
